/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.4.0",
  "gitBuildTime": "2025-12-02T19:11:06.631Z",
  "gitBuildVersion": "1.4.0",
  "gitCommitId": "68c1fab",
  "gitCommitIdFull": "68c1fab18f8e1bbc460c616f6d980bbfd1137c25",
  "gitCommitTime": "2025-12-02T19:10:00.000Z",
  "version": "1.4.0-2025-12-02T19:10:00.000Z-(68c1fab)"
};
